import React, {useState} from 'react';
import {DataGrid} from '@material-ui/data-grid';
import {
    EventDateColumnType, EventDateOnlyColumnType,
    NumberPlateColumnType
} from "../../../components/Grid/Columns";
import {useNavigate} from "react-router";
import Header from "./Header";
import {useGrid} from "../../../hooks/crud/Grid";
import {useTranslation} from "react-i18next";
import {GridSkeleton} from "../../../components/GridSkeleton";
import {Filter} from "./Filter";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import FineRepository from "../../../repositories/FineRepository";
import {format, parse} from "date-fns";
import FineLogView from "../../AuditLog/FineLog";
import { saveAs } from 'file-saver'
import ParkingEventRepository from "../../../repositories/ParkingEventRepository";

const FineListView = () => {

	const navigate = useNavigate();
	const repository = new FineRepository();
	const {t}  = useTranslation();
    const [showLog, setShowLog] = useState(null);
	const [blockedWindow, setBlockedWindow] = useState(false);

    const handleEditItemClick = (event) => {
    }

    const handleShowParkingEvent = async (value) => {

        const dateFormat = 'yyyy-MM-dd';
        const eventRepository = new ParkingEventRepository();
        const eventData = (await eventRepository.getById(value)).data;
        const dateFrom = format(parse(eventData.EntryDate, dateFormat + " HH:mm:ss", new Date()), dateFormat);
        const dateTo = format(parse(eventData.ExitDate, dateFormat + " HH:mm:ss", new Date()), dateFormat);

	    navigate(`/app/parking-events?DateFrom=${dateFrom}&DateTo=${dateTo}&query=${value}`);
    }

    const handleOnDownload = async (e) => {
	    setBlockedWindow(true);
	    try {
            const response = await repository.export(Object.assign({}, filter, { sort: sort }));
            const fileName = "[" + filter.DateFrom + " - " + filter.DateTo + "] - Fines.csv";
            saveAs(response.data, fileName);
        } catch (e) {
        } finally {
            setBlockedWindow(false);
        }
    }

    const today = format(new Date(), 'yyyy-MM-dd');
    const defaultFilter = { DateFrom: today, DateTo: today };

	const { items,
        totalCount,
        itemsOnPage,
        onPage,
        isSearching,
        onFilterChangedHandler,
        onSortChangedHandler,
        filter,
        sort,
        updateGrid,
        setFilterValue } = useGrid(repository, { onEdit: handleEditItemClick, defaultSort: 'Id|desc', defaultFilter: defaultFilter });

	const columns = [
        { field: 'Id', headerName: t('ID'), width: 60, sortable: false },
        { field: 'ParkingZoneName', headerName: t('Parking zone'), width: 250, sortable: false  },
        { field: 'NumberPlate', headerName: t('Plate'), ... NumberPlateColumnType  },
        { field: 'Amount', headerName: t('Amount'), width: 100, sortable: false  },
        { field: 'CreatedAt', headerName: t('Date'), width: 70, sortable: false, ...EventDateOnlyColumnType  },
        {
            field: 'ParkingEventId', headerName: t('Parking event'), width: 140, sortable: false,
            renderCell: (cell) => {
                return <a href={"#"} onClick={e => handleShowParkingEvent(cell.value)}>{cell.value}</a>;
            }
        },
        { field: 'EntryDate', headerName: t('Entry'), width: 155, sortable: false, ...EventDateColumnType  },
        { field: 'ExitDate', headerName: t('Exit'), width: 488, sortable: false, ...EventDateColumnType  },
        { field: 'ExportedDate', headerName: t('Export date'), ...EventDateColumnType },
        { field: 'FineSystemId', headerName: t('Parkenforcer ID'), width: 150, sortable: false  },
        { field: 'ParkingCountBefore', headerName: t('Adjacent'),  width: 100, sortable: false,
            renderCell: (cell) => {
                return <span>{cell.row.ParkingCountBefore} / {cell.row.ParkingCountAfter}</span>;
            }
        },
        { field: 'CancelledReason', headerName: t('Cancelled'), width: 120, sortable: false  }
    ];

	return (

        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <>
            {showLog && <FineLogView id={showLog} onClose={e => setShowLog(null)} />}
            <GridSkeleton title={t("Fines")}
                          isSearching={isSearching}
                          isBlocked={blockedWindow}
                          header={(<Header onRefresh={updateGrid} onDownload={handleOnDownload} />)}
                          filter={(<Filter onUpdateFilter={setFilterValue} onFilterChanged={onFilterChangedHandler} onSortChanged={onSortChangedHandler} filter={filter} sort={sort}/>)}
                          grid={(<DataGrid
                                       disableMultipleSelection={true}
                                       disableColumnFilter
                                       rows={items()}
                                       rowCount={totalCount()}
                                       columns={columns}
                                       pageSize={itemsOnPage}
                                       paginationMode="server"
                                       sortingMode="server"
                                       disableColumnSelector={true}
                                       disableSelectionOnClick={true}
                                       disableColumnMenu={true}
                                       onPageChange={onPage}
                                       rowsPerPageOptions={[itemsOnPage]}
                                       hideFooterSelectedRowCount={true}
                             />)}
            />
            </>
        </MuiPickersUtilsProvider>
	);
};

export default FineListView;